import { useEffect, useState } from "react";
import { fetchEvents } from "./api";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(0);
  const limit = 10;

  useEffect(() => {
    const loadEvents = async () => {
      try {
        const data = await fetchEvents(limit, page * limit);
        setEvents(data.list || []);
      } catch (error) {
        console.error("Error fetching events:", error);
        setEvents([]);
      }
    };
    loadEvents();
  }, [page]);

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  return (
    <div className="events-container">
      <div className="events-header">
        <h1>Event History</h1>
      </div>

      <div className="events-table-container">
        <table className="events-table">
          <thead>
            <tr>
              <th>Event Type</th>
              <th>Session ID</th>
              <th>Profile ID</th>
              <th>Source</th>
              <th>Timestamp</th>
              <th>Properties</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.itemId}>
                <td>
                  <span className="event-type-badge">
                    {event.eventType}
                  </span>
                </td>
                <td>{event.sessionId || 'N/A'}</td>
                <td>{event.profileId || 'N/A'}</td>
                <td>
                  {event.source ? (
                    <div className="source-info">
                      <span>{event.source.name || 'Unknown'}</span>
                      <span className="source-type">{event.source.type}</span>
                    </div>
                  ) : 'N/A'}
                </td>
                <td>{formatDate(event.timestamp)}</td>
                <td>
                  <div className="properties-list">
                    {Object.entries(event.properties || {}).map(([key, value]) => (
                      <div key={key} className="property-item">
                        <span className="property-key">{key}:</span>
                        <span className="property-value">
                          {typeof value === 'object' ? JSON.stringify(value) : value.toString()}
                        </span>
                      </div>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button
          onClick={() => setPage(page - 1)}
          disabled={page === 0}
          className="pagination-btn"
        >
          Previous
        </button>
        <span className="page-info">Page {page + 1}</span>
        <button
          onClick={() => setPage(page + 1)}
          className="pagination-btn"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Events;
